import axios from 'axios';
import Vue from 'vue';
import zenscroll from 'zenscroll';
import Errors from '../classes/errors';
import { handleCloseDropdownOnBlur, setCaptchaEuScript } from '../utils';
import { getFormRenderToken } from '../services/anti-bot';
import { isCaptchaEnabled } from '../services/captcha';

Vue.component('business-partner-form-component', {
    props: {
        siteHandle: {
            value: String,
        },
        captchaEuPublicKey: {
            value: String,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            formRenderToken: '',
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            countryHandle: '',

            vehiclesFleet: null,
            selectedVehiclesFleet: null,

            electricVehiclesFleet: null,
            selectedElectricVehiclesFleet: null,

            dropdownCountry: null,

            isNumberValid: true,
        };
    },

    computed: {
        isCompanyInputVisible: function () {
            return this.requestType === 'business';
        },
        isSubmitLoading: function () {
            return this.submitting ? 'button--loading' : '';
        },
    },

    watch: {},

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        if (this.siteHandle !== 'default') {
            this.countryHandle = this.siteHandle;
        }

        setCaptchaEuScript();

        getFormRenderToken().then((token) => {
            this.formRenderToken = token;
        });
        handleCloseDropdownOnBlur('#vehicles-fleet-dropdown');
        handleCloseDropdownOnBlur('#electric-vehicles-fleet-dropdown');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        scrollToFirstError() {
            Vue.nextTick(() => {
                let firstError = document.querySelector(
                    '.new-input__container--error',
                );
                zenscroll.center(firstError);
            });
        },

        scrollToTop() {
            Vue.nextTick(() => {
                zenscroll.toY(0);
            });
        },

        async onSubmit(event) {
            event.preventDefault();
            const form = event.currentTarget;
            let formData = new FormData(form);
            const data = {};

            for (let [key, val] of formData.entries()) {
                Object.assign(data, { [key]: val });
            }

            if (this.submitting) return;

            this.submitting = true;

            if (!this.isNumberValid) {
                this.submitting = false;
                return;
            }

            try {
                if (!(await isCaptchaEnabled())) {
                    await this.handleDataSubmit(form);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(form, captchaSolution);
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        async handleDataSubmit(form, captchaSolution) {
            try {
                const formData = new FormData(form);
                formData.append('formRenderToken', this.formRenderToken);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }
                const { data } = await axios.post('/', formData);
                const result = data;

                if (result.data.errors) {
                    this.submitting = false;
                    this.errors.clear();
                    this.errors.record(result.data.errors);

                    this.scrollToFirstError();
                    return;
                }

                this.errors.clear();
                this.isNumberValid = true;

                window.location = this.$refs.redirectUrl.value;
            } catch (e) {
                throw new Error(e);
            }
        },

        toggleDropdown(event) {
            event.preventDefault();
            let element = event.currentTarget;

            while ((element = element.parentElement)) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');
                }
            }
        },

        setDropdownVehiclesFleet(event) {
            this.vehiclesFleet = event.currentTarget.dataset.text;
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.selectedVehiclesFleet = value;
        },

        setDropdownElectricVehiclesFleet(event) {
            this.electricVehiclesFleet = event.currentTarget.dataset.text;
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.selectedElectricVehiclesFleet = value;
        },
    },
});
